module.exports = __webpack_public_path__ + "img/workContents03_sp_01.49869b1f.png";